// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4b65d11d","455":"9966e906","977":"8300a6bf"}[chunkId] + ".chunk.js";
};